import { render, staticRenderFns } from "./SettlementWizard.vue?vue&type=template&id=19e9a413"
import script from "./SettlementWizard.vue?vue&type=script&lang=js"
export * from "./SettlementWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports